<div [formGroup]="form" class="w-full border-round-xl h-full pt-1 pb-1 pl-4 pr-4 border-1" [style]="{
                'backgroundColor': (eyeSide === Eye.LEFT ? '#9747FF08' : '#FD52B908'),
                'borderColor': (eyeSide === Eye.LEFT ? '#9747FF' : '#FD52B9'),
            }">
    <h2 class="mb-4" [style]="'color: ' + (eyeSide === Eye.LEFT ? '#9747FF' : '#FD52B9')">
        {{ eyeSide === Eye.LEFT ? "Left (OS)" : "Right (OD)" }}
    </h2>

    <div class="grid formgrid">
        <div class="field col-12">
            <label for="measurementType" class="block text-900 font-medium mb-2">
                Measurement Type
            </label>

            <p-selectButton formControlName="measurementType" id="measurementType"
                [options]="['Cycloplegic','Non-Cyclo']"
                [styleClass]="eyeSide === Eye.LEFT ? 'left-eye-select' : 'right-eye-select'" [allowEmpty]="false" />
        </div>

        <div class="field col-4">
            <label for="sphere" class="block text-900 font-medium mb-2">
                Sph (D)
            </label>
            <p-inputNumber id="sphere" formControlName="sphere" class="w-full" styleClass="w-full"
                [min]="MEASUREMENT_RANGES['sphere'].min" [max]="MEASUREMENT_RANGES['sphere'].max"
                [minFractionDigits]="0" [maxFractionDigits]="2" />
            <div class="mb-1 h-3 overflow-hidden"
                [ngClass]="{'text-red-500': form.get('sphere')?.invalid && form.get('sphere')?.touched, 'text-transparent': !(form.get('sphere')?.invalid && form.get('sphere')?.touched)}">
                <small class="text-xs leading-3"
                    *ngIf="form.get('sphere')?.invalid && form.get('sphere')?.touched">Sphere should be between
                    {{MEASUREMENT_RANGES["sphere"].min}} and {{MEASUREMENT_RANGES["sphere"].max}}.</small>
                <small class="text-xs leading-3"
                    *ngIf="!(form.get('sphere')?.invalid && form.get('sphere')?.touched)">&nbsp;</small>
            </div>
        </div>

        <div class="field col-4">
            <label for="cylinder" class="block text-900 font-medium mb-2">
                Cyl (D)
            </label>
            <p-inputNumber id="cylinder" formControlName="cylinder" class="w-full" styleClass="w-full"
                [min]="MEASUREMENT_RANGES['cylinder'].min" [max]="MEASUREMENT_RANGES['cylinder'].max"
                [minFractionDigits]="0" [maxFractionDigits]="2" />
            <div class="mb-1 h-3 overflow-hidden"
                [ngClass]="{'text-red-500': form.get('cylinder')?.invalid && form.get('cylinder')?.touched, 'text-transparent': !(form.get('cylinder')?.invalid && form.get('cylinder')?.touched)}">
                <small class="text-xs leading-3"
                    *ngIf="form.get('cylinder')?.invalid && form.get('cylinder')?.touched">Cylinder should be between
                    {{MEASUREMENT_RANGES["cylinder"].min}} and {{MEASUREMENT_RANGES["cylinder"].max}}.</small>
                <small class="text-xs leading-3"
                    *ngIf="!(form.get('cylinder')?.invalid && form.get('cylinder')?.touched)">&nbsp;</small>
            </div>
        </div>
        <div class="field col-4">
            <label for="axis" class="block text-900 font-medium mb-2">
                Axis (°)
            </label>
            <p-inputNumber id="axis" formControlName="axis" class="w-full" styleClass="w-full"
                [min]="MEASUREMENT_RANGES['axis'].min" [max]="MEASUREMENT_RANGES['axis'].max" [minFractionDigits]="0"
                [maxFractionDigits]="2" />
            <div class="mb-1 h-3 overflow-hidden"
                [ngClass]="{'text-red-500': form.get('axis')?.invalid && form.get('axis')?.touched, 'text-transparent': !(form.get('axis')?.invalid && form.get('axis')?.touched)}">
                <small class="text-xs leading-3" *ngIf="form.get('axis')?.invalid && form.get('axis')?.touched">Axis
                    should be between
                    {{MEASUREMENT_RANGES["axis"].min}} and {{MEASUREMENT_RANGES["axis"].max}}.</small>
                <small class="text-xs leading-3"
                    *ngIf="!(form.get('axis')?.invalid && form.get('axis')?.touched)">&nbsp;</small>
            </div>
        </div>

        <div class="field col-5 flex flex-column justify-content-end">
            <label for="axialLength" class="block text-900 font-medium mb-2">
                Axial Length (mm)
            </label>
            <p-inputNumber id="axialLength" formControlName="axialLength" class="w-full" styleClass="w-full"
                [min]="MEASUREMENT_RANGES['axialLength'].min" [max]="MEASUREMENT_RANGES['axialLength'].max"
                [minFractionDigits]="0" [maxFractionDigits]="2" />
            <div class="mb-1 h-3 overflow-hidden"
                [ngClass]="{'text-red-500': form.get('axialLength')?.invalid && form.get('axialLength')?.touched, 'text-transparent': !(form.get('axialLength')?.invalid && form.get('axialLength')?.touched)}">
                <small class="text-xs leading-3"
                    *ngIf="form.get('axialLength')?.invalid && form.get('axialLength')?.touched">Axial Length should be
                    between {{MEASUREMENT_RANGES["axialLength"].min}} and
                    {{MEASUREMENT_RANGES["axialLength"].max}}.</small>
                <small class="text-xs leading-3"
                    *ngIf="!(form.get('axialLength')?.invalid && form.get('axialLength')?.touched)">&nbsp;</small>
            </div>
        </div>

        <div class="field col-2 flex flex-row justify-content-center align-items-center">
            <span class="block text-900">OR</span>
        </div>

        <div class="field col-5 flex flex-column justify-content-end">
            <label for="kValue" class="block text-900 font-medium mb-2">
                K Value (mm)
            </label>
            <p-inputNumber id="kValue" formControlName="kValue" class="w-full" styleClass="w-full"
                [min]="MEASUREMENT_RANGES['kValue'].min" [max]="MEASUREMENT_RANGES['kValue'].max"
                [minFractionDigits]="0" [maxFractionDigits]="2" />
            <div class="mb-1 h-3 overflow-hidden"
                [ngClass]="{'text-red-500': form.get('kValue')?.invalid && form.get('kValue')?.touched, 'text-transparent': !(form.get('kValue')?.invalid && form.get('kValue')?.touched)}">
                <small class="text-xs leading-3" *ngIf="form.get('kValue')?.invalid && form.get('kValue')?.touched">K
                    Value should be between
                    {{MEASUREMENT_RANGES["kValue"].min}} and {{MEASUREMENT_RANGES["kValue"].max}}.</small>
                <small class="text-xs leading-3"
                    *ngIf="!(form.get('kValue')?.invalid && form.get('kValue')?.touched)">&nbsp;</small>
            </div>
        </div>
    </div>
</div>